import script from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDialog.vue?vue&type=script&setup=true&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=61d0ac58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d0ac58"]])

export default __exports__